import { FilterCheckbox } from '../FilterAccordion';
import { forwardRef } from 'react';
import styled from 'styled-components';

export const FilterCheckboxChipMetric = styled.span`
    font-weight: 500;
    margin-left: 0.5rem;
    color: ${({ theme }) => theme.gray_600};
    text-transform: uppercase;
`;

const FilterCheckboxChip = forwardRef((props, ref) => (
    <FilterCheckbox {...props} ref={ref} />
));

export default FilterCheckboxChip;
